// extracted by mini-css-extract-plugin
module.exports = {"skeletonContainer":"az_Xnb"};